import CrownForm from "./CrownForm";
import Tracking from "./Tracking";

const consentEvt = (e: Event) => {
  const acceptedCategories = (<CustomEvent>e).detail || {};

  if (acceptedCategories?.performance) {
    const tracking = new Tracking();
    tracking.init();
  } else {
    Tracking.clear();
  }
};

window.addEventListener("cf_consent", consentEvt);
window.addEventListener("cf_consent_loaded", consentEvt);

const registerInterestForm =
  document.querySelector<HTMLFormElement>("#register-interest");
if (registerInterestForm) {
  new CrownForm({
    el: registerInterestForm,

    url: "/wp-content/themes/crownoilestates/ajax/RegisterInterestForm.php",

    button: {
      defaultText: "Register my interest",
      submittingText: "Processing...",
    },

    success() {
      window.location.href = "/thank-you/";
    },
  });
}

const requestCallbackForm =
  document.querySelector<HTMLFormElement>("#request-callback");
if (requestCallbackForm) {
  new CrownForm({
    el: requestCallbackForm,

    url: "/wp-content/themes/crownoilestates/ajax/RequestCallbackForm.php",

    button: {
      defaultText: "Request callback",
      submittingText: "Processing...",
    },

    success() {
      window.location.href = "/thank-you/";
    },
  });
}

window.addEventListener("DOMContentLoaded", () => {
  const headerHeight = document.querySelector("header")?.offsetHeight || 130;
  const padding = 16 * 2;

  document.body.style.setProperty(
    "--form-offset",
    `${headerHeight + padding}px`
  );
});
